import React from "react"
import Layout from "../components/layout"
import HeaderBanner from "../components/headerBanner"
import HomeCarousel from "../components/carousel/homepageCarousel"
import { HorizontalSpacer } from "@omnichannel/ace-b2b-elements"
import SplashModal from "../components/splashModal"
import FeaturedBrandsRow from "../components/featuredBrandsRow"
import RedHotSale from "../components/carousel/redHotSale"
import SEO from "../components/seo"

const Homepage = props => {

  return (
    <>
      <SEO
        keywords="hardware, home improvements, garden, lawn, tools, automotive" />
      <Layout {...props}>
        <HeaderBanner />
        <HomeCarousel />
        <HorizontalSpacer height={"2.4rem"} />
        <RedHotSale />
        <FeaturedBrandsRow />
        <SplashModal />
      </Layout>
    </>
  )
}

export default Homepage
